import(/* webpackMode: "eager" */ "/app/src/app/(home)/schemas/scalar/page.tsx");
